import { render, staticRenderFns } from "./contactButton.vue?vue&type=template&id=4ae4e440"
import script from "./contactButton.vue?vue&type=script&lang=js"
export * from "./contactButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports